import React from "react";

import { useSelector } from "react-redux";
import { components, MultiValueGenericProps } from "react-select";

import {
  Group,
  Option,
  OptionsSearch,
} from "components/SearchInput/GlobalSearch";

import { AttachmentSearchFieldLabels } from "constants/attachmentSearch";
import { Settings } from "constants/settings";

import { selectAttachmentSearchOptions } from "selectors";

interface AttachmentOptionValue {
  label: string;
  value: { field: string; value: unknown };
}

function MultiValueLabel(props: MultiValueGenericProps<AttachmentOptionValue>) {
  const {
    data: {
      label,
      value: { field },
    },
  } = props;

  return (
    <components.MultiValueLabel {...props}>
      {AttachmentSearchFieldLabels[field]}
      {label}
    </components.MultiValueLabel>
  );
}

const attachmentOverrideComponents = {
  Group,
  MultiValueLabel,
  Option,
};

export function AttachmentSearch() {
  const options = useSelector(selectAttachmentSearchOptions);
  return (
    <OptionsSearch
      options={options}
      settingName={Settings.attachmentSearch}
      overridePlaceHolder="Filter attachments..."
      overrideComponents={attachmentOverrideComponents}
      closeMenuOnSelect={false}
    />
  );
}
